import React, {PropsWithChildren} from 'react';

import './SearchDropdown.scss';

interface ISearchItemProps {
    label: string;
}

export function SearchItem({label}: PropsWithChildren<ISearchItemProps>) {
    return (
        <div className="searchItem ellipsis">
            {label || (<>&nbsp;</>)}
        </div>
    )
}